import LayoutWithSideMenu from "./LayoutWithSideMenuContainer";

export default LayoutWithSideMenu;
